import { gql } from '@apollo/client'

import { EVENT_FRAGMENT } from '../../../common/graphql/fragments'

import { INGREDIENT_NODE_FRAGMENT } from '../fragments'

const REPLACE_INGREDIENT_MUTATION = gql`
  mutation replaceIngredient($idToReplace: ID!, $replacementIds: [ID!]!) {
    replaceIngredient(
      idToReplace: $idToReplace
      replacementIds: $replacementIds
    ) {
      results {
        ...IngredientNodeFragment
      }
      latestEvent {
        ...EventFragment
      }
    }
  }
  ${INGREDIENT_NODE_FRAGMENT}
  ${EVENT_FRAGMENT}
`

export default REPLACE_INGREDIENT_MUTATION
